'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { HeroBanner } from '@/components/frontend/common/hero-banner';
import { Typography } from '@/components/ui/typography';

export function MLMCalculatorPageContent() {
    const t = useTranslations('mlmCalculator');

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
            <HeroBanner
                page="mlm-calculator"
                title={t('title') || 'MLM Calculator'}
                description={t('description') || 'Calculate your MLM earnings and commissions with our free calculator tool.'}
                pill={t('pill') || 'Calculator'}
            />

            <SectionWrapper variant="default" padding="lg" className="relative overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40">
                    <div className="absolute left-10 top-10 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl" />
                    <div className="absolute right-10 bottom-10 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
                </div>

                <div className="relative z-10 max-w-7xl mx-auto text-center">
                    <Typography variant="h3" className="text-gray-900 dark:text-white">
                        Page under construction
                    </Typography>
                </div>
            </SectionWrapper>
        </div>
    );
}

